import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { Grid, Typography } from '@material-ui/core';
import Card from '../../../components/Card';
import Loader from '../../../components/Loader';
import Modal from '../../../components/Modal';
import Select from '../../../components/Select';
import Button from '../../../components/Button';
import Table from './Table';
import Form from './Form';

import { clearPriceTable, handleRemoveAndReplaceModalOpen } from '../store/actions';
import { loadTables, removeAndReplaceTable } from '../store/thunk';

export default function PriceTable() {
  const dispatch = useDispatch();

  const { path } = useRouteMatch();
  const isPriceTableInitialRegistration = path.split('/').includes('cadastro-inicial');

  const [isDeleteReplaceTableWarningModalOpen, setIsDeleteReplaceTableWarningModalOpen] = useState(false);
  const [selectDeleteReplaceTable, setSelectDeleteReplaceTable] = useState('');

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { tables, toRemoveAndReplaceTable, isRemoveAndReplaceModalOpen, isLoading } = useSelector(state => state.priceTable);

  const deleteReplaceTables = tables?.map(item => {
    return {
      label: item?.typePrice,
      value: item?.typePrice
    }
  });

  useEffect(() => {
    dispatch(clearPriceTable());
  }, []);

  useEffect(() => {
    if(establishmentId) {
      dispatch(loadTables(userId, establishmentId));
    }
  }, [establishmentId]);

  return(
    <>
      {isRemoveAndReplaceModalOpen && (
        <Modal
          id='delete-replace-price-table-modal'
          title='Tabela de estacionamento para substituição'
          maxWidth='sm'
          open={isRemoveAndReplaceModalOpen}
          onClose={() => dispatch(handleRemoveAndReplaceModalOpen(false))}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography>
                Selecione uma nova tabela de estacionamento para substituir a tabela <b>{toRemoveAndReplaceTable}</b> no cliente/OS.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Select
                name='delete-replace-price-table-select'
                label='Tabela de estacionamento'
                options={deleteReplaceTables?.filter(item => item?.label != toRemoveAndReplaceTable)}
                value={selectDeleteReplaceTable}
                onChange={event => setSelectDeleteReplaceTable(event.target.value)}
              />
            </Grid>
            <Grid container xs={12} justify='flex-end' spacing={1}>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  type='button'
                  color='error'
                  loading={isLoading}
                  onClick={() => dispatch(handleRemoveAndReplaceModalOpen(false))}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  type='button'
                  color='success'
                  loading={isLoading}
                  onClick={() => {
                    dispatch(removeAndReplaceTable(userId, establishmentId, selectDeleteReplaceTable, toRemoveAndReplaceTable)).then(() => {
                      dispatch(handleRemoveAndReplaceModalOpen(false));
                      setIsDeleteReplaceTableWarningModalOpen(true);
                    });
                  }}
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Modal>
      )}
      {isDeleteReplaceTableWarningModalOpen && (
        <Modal
          id='delete-replace-price-table-warning-modal'
          title='Atenção'
          maxWidth='sm'
          open={isDeleteReplaceTableWarningModalOpen}
          onClose={() => setIsDeleteReplaceTableWarningModalOpen(false)}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography>
                Sincronize seus dispositivos para receber as informações atualizadas! Caso não sicronize isso pode gerar erros na sua operação!
              </Typography>
            </Grid>
            <Grid container justify='flex-end'>
              <Button
                type='button'
                color='success'
                onClick={() => setIsDeleteReplaceTableWarningModalOpen(false)}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
        </Modal>
      )}
      <Grid container style={{ marginBottom: 15, padding: 10, backgroundColor: '#F6EBE9', border: '1px solid #E5E7EC', borderRadius: 5 }}>
        <Grid item xs={12}>
          <ul style={{ lineHeight: 1 }}>
            <li style={{ color: '#AA513D' }}>
              <b>Sincronize o aplicativo operacional nas "2 setas circulares" na tela principal após criação e edição da sua tabela de preço.</b>
            </li>
            <br />
            <li style={{ color: '#AA513D' }}>
              <b>O campo “a partir de” precisa ser igual ao maior valor do “Até”. Assista <a href='https://www.youtube.com/watch?v=GHycEdOrhTg' target='_blank' style={{ color: 'inherit' }}>este vídeo</a> para entender e evitar erros.</b>
            </li>
            <br />
            <li style={{ color: '#AA513D' }}>
              <b>Aprenda a criar tolerância <a href='https://www.youtube.com/watch?v=YugWjPQJsE4' target='_blank' style={{ color: 'inherit' }}>neste vídeo</a>.</b>
            </li>
            <br />
            <li style={{ color: '#AA513D' }}>
              <b>Assista <a href='https://www.youtube.com/watch?v=v05frQ4quKc' target='_blank' style={{ color: 'inherit' }}>este vídeo</a> para criar os mensalistas.</b>
            </li>
          </ul>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <Card id="price-table-form" title={isPriceTableInitialRegistration ? "Cadastre uma tabela de estacionamento" : "Cadastre uma tabela de preço"}>
            <Form />
          </Card>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Card title="Minhas tabelas de estacionamento">
            <Grid item xs={12}>
              <Loader isLoading={isLoading}>
                {tables.length > 0 ? (
                  tables.map((table, index) => <Table key={index} data={table} />)
                ) : (
                  <Grid>
                    <Typography variant="h6" color="textSecondary">Não há tabelas cadastradas</Typography>
                    <Typography variant="subtitle1" color="textSecondary">Cadastre a sua primeira tabela ao lado!</Typography>
                  </Grid>
                )}
              </Loader>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}